import React, { useEffect, createRef } from 'react';

const SounderPlayer = ({ episodeId }) => {
  const containerRef = createRef();

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `(function(){var qs,js,q,s,d=document,gi=d.getElementById,ce=d.createElement,gt=d.getElementsByTagName,id="soun_der",b="https://embed.sounder.fm";if(!gi.call(d,id)){js=ce.call(d,"script");js.id=id;js.src=b+"/embed.js";q=gt.call(d,"script")[0];q.parentNode.insertBefore(js,q)}})();`;

    const containerNode = containerRef.current;
    containerNode.appendChild(script);

    // Clean up.
    return () => {
      containerNode.removeChild(script);
      document.getElementById('soun_der').remove();
    };
  }, []);

  return (
    <div ref={containerRef}>
      <div
        className="sounder-widget"
        data-url={`https://embed.sounder.fm/play/${episodeId}`}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default SounderPlayer;
